/* global Modal */
  
if (!customElements.get('product-video')) {   
    class ProductVideo extends HTMLElement {
        constructor() {
          super();
          this.documentClickHandler = this.handleDocumentClick.bind(this);
          this.close = this.querySelector('.close-video-modal');
          this.videoFrame = this.querySelector('#youtube-video');
    
          document.addEventListener("click", this.documentClickHandler);
          this.addEventListener('click', this.handleCloseClick);
        }

        handleDocumentClick(evt){
           if(!evt.target.closest('.product__video-card')) return;
           let url = evt.target.closest('.product__video-card').dataset.url;
           this.videoFrame.src = url;
           this.style.display = "block";
        }

        handleCloseClick(evt){
            if(!evt.target.matches('.close-video-modal')) return;
            this.style.display = "none";
            this.videoFrame.src = "";
        }
      }
  
      customElements.define('product-video', ProductVideo);
  }